__turbopack_context__.v({
  "kit-options-grid": "KitOptionsGrid-module-scss-module__oa1eOa__kit-options-grid",
  "kit-options-grid__items": "KitOptionsGrid-module-scss-module__oa1eOa__kit-options-grid__items",
});
